import client from './client';

export const getAll = async (): Promise<SanityStory[]> => {
  const query = `*[_type=="story"]{
    title->{textContent},
    videoUrl,
    mainImage{
      alt,
      asset->{url}
    }
  }`;

  const data = await client.fetch<SanityStory[]>(query);
  return data;
};
